// Elegant gradient placeholder for product images.
// Deterministic by product slug (same product = same color).

const CATEGORY_COLORS = {
  sonno: { from: "#6B7BA6", to: "#3D4A6B", emoji: "🌙" },
  alimentazione: { from: "#D67A5C", to: "#A24430", emoji: "🥕" },
  emozioni: { from: "#E09866", to: "#B86238", emoji: "🌋" },
  autonomia: { from: "#8FA56B", to: "#5C7340", emoji: "👟" },
  linguaggio: { from: "#7B9CAB", to: "#4E6B7A", emoji: "✏️" },
  "fratelli-amicizie": { from: "#BC828A", to: "#8B5358", emoji: "🤝" },
  scuola: { from: "#A88361", to: "#6E5638", emoji: "🎒" },
  "gioco-outdoor": { from: "#6FA882", to: "#3F6B52", emoji: "🎨" },
};

const KIND_LABELS = {
  libro: "Libro",
  gioco: "Gioco",
  app: "App",
};

function hashSlug(slug) {
  let h = 0;
  for (let i = 0; i < (slug || "").length; i++) h = (h * 31 + slug.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function ProductImage({ product, className = "", size = "md" }) {
  const { from, to, emoji } = CATEGORY_COLORS[product?.category] || CATEGORY_COLORS["gioco-outdoor"];
  const angle = (hashSlug(product?.slug || "") % 60) + 110; // 110-170 deg
  const kindLabel = KIND_LABELS[product?.kind] || "";
  const fontSize = size === "lg" ? "text-6xl sm:text-7xl" : size === "sm" ? "text-3xl" : "text-5xl";

  if (product?.image_url) {
    return (
      <div className={`relative overflow-hidden ${className}`}>
        <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" />
      </div>
    );
  }

  return (
    <div
      className={`relative overflow-hidden flex items-center justify-center ${className}`}
      style={{ background: `linear-gradient(${angle}deg, ${from}, ${to})` }}
      aria-label={product?.name}
    >
      {/* subtle noise/grain */}
      <div className="absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
        backgroundImage: "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)",
        backgroundSize: "3px 3px",
      }} />
      <span className={`${fontSize} drop-shadow-md`} aria-hidden>{emoji}</span>
      {kindLabel && (
        <span className="absolute top-2 left-2 text-[10px] font-semibold tracking-wide uppercase bg-white/85 text-[#1A362D] px-2 py-0.5 rounded-full">
          {kindLabel}
        </span>
      )}
    </div>
  );
}
